module.exports = __webpack_public_path__ + "img/txt.e198dd67.png";